import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { GpuMediaQueryBreakpoints, GPU_MEDIA_QUERIES } from '@geneplanet/ngx-ui/src/lib/layout';

@UntilDestroy()
@Component({
  selector: 'app-full-image-modal',
  templateUrl: './full-image-modal.component.html',
  styleUrls: ['./full-image-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullImageModalComponent implements OnInit {
  @HostBinding('class') classAttribute = 'overflow-hidden';

  @Input() title: string;
  @Input() description: string;
  @Input() button: string;
  @Input() bgImg = '';
  @Input() bgImageType = 'jpg';
  @Input() dataTrackClose: string;
  @Input() dataTrackClick: string;

  @Input() closeClick = new EventEmitter<boolean>();
  @Input() buttonClick = new EventEmitter<boolean>();

  public viewHasInitialized = false;
  public isMobile = false;

  constructor(
    public modal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver
      .observe(GPU_MEDIA_QUERIES[GpuMediaQueryBreakpoints.SM_DOWN])
      .pipe(untilDestroyed(this))
      .subscribe((value: BreakpointState) => {
        this.isMobile = value.matches;
        this.cdr.markForCheck();
      });
  }

  ngOnInit() {
    /* Fixes black screen on init. Can be removed with ng-bootstrap ^9.0 */
    setTimeout(() => {
      this.viewHasInitialized = true;
      this.cdr.markForCheck();
    }, 0);
  }

  close() {
    this.modal.dismiss();
    this.closeClick.emit();
  }
}
